// Mock data for MoveraCare Mobility NEMT website

export const mockData = {
  company: {
    name: "MoveraCare Mobility",
    phone: "(832) 925-2128",
    dispatchPhone: "(832) 925-2128",
    fax: "(713) 583-2334",
    email: "dispatch@moveracaremobility.com",
    address: "Houston, Texas",
    hours: "Mon–Sat 6:00 AM – 7:00 PM · Sunday 12:00 PM – 5:00 PM"
  },
  
  services: [
    {
      id: 1,
      title: "Wheelchair Transportation",
      description: "Professional wheelchair-accessible transport with drivers who assist passengers during transport.",
      icon: "Wheelchair",
      target: "Patients requiring wheelchair accessibility"
    },
    {
      id: 2,
      title: "Ambulatory / Sedan Transport",
      description: "Comfortable sedan transport for ambulatory patients requiring medical appointments.",
      icon: "Car",
      target: "Ambulatory patients"
    },
    {
      id: 3,
      title: "Dialysis Recurring Transport",
      description: "Reliable recurring transportation services for dialysis patients on consistent schedules.",
      icon: "Calendar",
      target: "Dialysis centers and patients"
    },
    {
      id: 4,
      title: "Hospital Discharge Transport",
      description: "Safe and timely transport from hospital to home or care facility after discharge.",
      icon: "Hospital",
      target: "Hospitals and discharge planners"
    },
    {
      id: 5,
      title: "Skilled Nursing Facility Transport",
      description: "Dedicated transportation for nursing facility residents to medical appointments.",
      icon: "Building2",
      target: "Skilled nursing facilities"
    }
  ],
  
  whyChoose: [
    {
      icon: "Clock",
      title: "Punctuality Focus",
      description: "We prioritize on-time performance for medical appointments"
    },
    {
      icon: "Sparkles",
      title: "Clean & Sanitized Vehicles",
      description: "Vehicles are cleaned and sanitized between transports"
    },
    {
      icon: "Shield",
      title: "Professional Drivers",
      description: "Drivers who assist passengers during transport"
    },
    {
      icon: "MapPin",
      title: "Dispatch Coordination",
      description: "Trip coordination and communication throughout the ride"
    },
    {
      icon: "FileCheck",
      title: "Credentialing-Ready Compliance",
      description: "Licensing, insurance, and HIPAA-conscious operations"
    }
  ],
  
  trustBadges: [
    {
      icon: "ShieldCheck",
      title: "Licensed & Insured",
      description: "Fully licensed and insured operations"
    },
    {
      icon: "Wheelchair",
      title: "Wheelchair Accessible",
      description: "Wheelchair-accessible vehicles"
    },
    {
      icon: "Lock",
      title: "HIPAA Conscious",
      description: "Patient privacy protected"
    },
    {
      icon: "UserCheck",
      title: "Professional Drivers",
      description: "Drivers assist passengers during transport"
    }
  ],
  
  healthcareFacilities: [
    {
      icon: "Hospital",
      title: "Discharge Transportation",
      description: "Reliable hospital discharge transport coordinated with care teams"
    },
    {
      icon: "Activity",
      title: "Dialysis Routes",
      description: "Dedicated recurring transportation for dialysis patients"
    },
    {
      icon: "Calendar",
      title: "Recurring Appointments",
      description: "Scheduled transport for ongoing medical treatments"
    },
    {
      icon: "Handshake",
      title: "Contract Partnerships",
      description: "Facility-level agreements with dedicated account management"
    }
  ],
  
  fleet: [
    {
      type: "Wheelchair Vans",
      count: 6,
      features: ["Wheelchair Accessible", "GPS Tracked", "Wheelchair Securement Systems", "Climate Controlled"]
    },
    {
      type: "Ambulatory Vehicles",
      count: 3,
      features: ["Comfortable Seating", "GPS Tracked", "Clean & Sanitized", "Professional Service"]
    }
  ],
  
  testimonials: [
    {
      name: "Skilled Nursing Facility Administrator",
      role: "Healthcare Professional",
      content: "MoveraCare consistently gets our residents to appointments safely and on time.",
      rating: 5
    },
    {
      name: "Houston Case Manager",
      role: "Healthcare Coordinator",
      content: "Excellent discharge transportation partner. Reliable and professional.",
      rating: 5
    },
    {
      name: "Dialysis Client",
      role: "Regular Client",
      content: "They help keep our dialysis schedule running smoothly every week.",
      rating: 5
    }
  ],
  
  complianceItems: [
    "Licensed & Insured",
    "HIPAA Conscious Operations",
    "Wheelchair-Accessible Vehicles",
    "MBE Certified"
  ]
};

export const images = {
  hero: "https://images.unsplash.com/photo-1773140278162-fd7df1043f0c",
  wheelchair: "https://images.unsplash.com/photo-1732194439331-08ec61c4df4f",
  hospital: "https://images.unsplash.com/photo-1764885449418-db6632922a19",
  facility: "https://images.pexels.com/photos/36897678/pexels-photo-36897678.jpeg"
};
